import { render, staticRenderFns } from "./itemLinks.vue?vue&type=template&id=3d3b28bb"
import script from "./itemLinks.vue?vue&type=script&lang=ts"
export * from "./itemLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementInformation: require('/codebuild/output/src3458403893/src/acredo-website/components/element/elementInformation.vue').default})
